export const authHeader = () => {
  // const authToken = localStorage.getItem("token");
  try {
    const authToken = JSON.parse(localStorage.getItem("auth")).token;
    // console.log("authToken", authToken);
    if (authToken) {
      // return { "x-access-token": authToken };
      return { Authorization: `Bearer ${authToken}` };
    } else {
      return {};
    }
  } catch (error) {
    console.log("error", error);
    return {};
  }
};

export const getHexStr = (size) => {
  return [...Array(size)]
    .map(() => Math.floor(Math.random() * 16).toString(16))
    .join("");
};
